import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./Welcome.scss"

class Welcome extends Component {
  constructor() {
    super()
    this.state = {
    }
  }
  render() {
    return (
      <section className="section section-welcome">
        <div className="padding">
          <div className="container">
            <div className="line">
              לקראת אירועי "ישראל - סיפור הצלחה" של ynet ו"ידיעות אחרונות"
          </div>
            <div className="line bold">
            שאלנו אתכם מהן הפלאפליות האהובות עליכם - והצפתם אותנו בתשובות.
            </div>
            <div className="line short">
            צוות המומחים שלנו בחר מתוכן את העולות לגמר - ועכשיו תורכם להכריע:
            </div>
            <div className="line">
            איפה מסתתרות המנות הטובות ביותר?
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.js